import React from 'react';

const NotFound: React.FunctionComponent = () => {
  return <p>404 Not Found</p>;
};

export default NotFound;
